import { Bill } from '@melio/platform-api';
import Big from 'big.js';
import { isNil } from 'lodash';

export const getBillPaidAmount = (bill: Partial<Bill>) =>
  !isNil(bill.balance) && !isNil(bill.amount) ? new Big(bill.amount).minus(bill.balance).toNumber() : 0;
